import { createFileRoute } from '@tanstack/react-router'
import React from "react";
import ComingSoonView from "../../ComingSoonView.tsx";

export const Route = createFileRoute('/_app/coming-soon')({
  component: RouteComponent,
})

function RouteComponent() {
  return <ComingSoonView />
}
